import Vue from "vue";
import App from "./App.vue";
import "./utils/unregisterServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./assets/css/main.css";
// import { makeServer } from "@/axios/mirage";
import VueProgressBar from "vue-progressbar";
import moment from "moment";
import DatetimePicker from "vuetify-datetime-picker";
// import "vuetify-datetime-picker/src/stylus/main.styl";
import "moment/locale/id"; // without this line it didn't work
import VueMask from "v-mask";
import VCalendar from "v-calendar";
import { registerFormAccessDirective } from "@/directives/v-form-access";
import AccessButton from "@/components/AccessButton.vue";
import PpdsCaption from "@/components/common/PpdsCaption.vue";
import VerifikasiTerkunciHint from "@/components/verifikasi/VerifikasiTerkunciHint.vue";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

moment.locale("id");

Vue.use(VueMask);
registerFormAccessDirective(Vue);
Vue.component("AccessButton", AccessButton);
Vue.component("PpdsCaption", PpdsCaption);
Vue.component("VerifikasiTerkunciHint", VerifikasiTerkunciHint);

const options = {
  color: "blue", // '#bffaf3',
  failedColor: "#874b4b",
  thickness: "3px",
  transition: {
    speed: "0.1s",
    opacity: "0.3s",
    termination: 300
  },
  autoRevert: true,
  location: "top",
  inverse: false
};
const ignoreWarnMessage =
  "The .native modifier for v-on is only valid on components but it was used on <div>.";
Vue.config.warnHandler = function(msg, vm, trace) {
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
};
Vue.config.productionTip = false;

Vue.use(VueProgressBar, options);

const sentryClient = Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router)
    })
  ],
  tracesSampleRate: parseFloat(process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE)
});

Vue.use(DatetimePicker);
Vue.use(VCalendar, {
  componentPrefix: "vc" // Use <vc-calendar /> instead of <v-calendar />
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");

// if (process.env.NODE_ENV === "development") {
//   makeServer();
// }

// export const httpBaseUrl = 'api';

